import React from 'react';
import { CatalogItemListRequest } from '@common/model/catalog/item/list.request';
import { coreCareerApi } from '@cp/entities/career';
import { coreCatalogApi } from '@cp/entities/catalog';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { useClientWebRouteProps } from '@cp/entities/clientWebRoutes';
import { useCatalogStats } from 'src/features/catalog';

export const useCatalogTemplateParameters = ({ listRequest }: { listRequest: CatalogItemListRequest }) => {
  const pageProps = useClientWebRouteProps<ClientWebPage.Catalog>();
  const { data: careerDictionary } = coreCareerApi.endpoints.getCareers.useQuery();
  const catalogStats = useCatalogStats();
  const { data: catalogListResponse } = coreCatalogApi.useGetItemsQuery(listRequest);

  return React.useMemo(() => {
    const t = careerDictionary?.[pageProps.careerId]?.translation;

    if (!t) {
      return {};
    }

    return {
      careerNamePlural: t.namePlural,
      careerNamePluralGenitive: t.namePluralGenitive,
      careerNameSingle: t.nameSingle,
      careerNameSingleAccusative: t.nameSingleAccusative,
      careerNameSingleGenitive: t.nameSingleGenitive,
      careerNameSinglePrepositional: t.nameSinglePrepositional,
      careerNameSingleInstrumental: t.nameSingleInstrumental,
      careerNameSingleDative: t.nameSingleDative,
      ...(catalogStats
        ? {
            catalogListTotalCount:
              catalogListResponse?.totalCount ?? catalogStats[pageProps.careerId]?.[pageProps.catalogType]?.totalCount ?? 0,
            catalogListPriceAverage: catalogStats[pageProps.careerId]?.[pageProps.catalogType]?.averagePrice ?? 0,
            catalogListPriceMin: catalogStats[pageProps.careerId]?.[pageProps.catalogType]?.minPrice ?? 0,
            catalogListPriceMax: catalogStats[pageProps.careerId]?.[pageProps.catalogType]?.maxPrice ?? 0,
          }
        : undefined),
    };
  }, [careerDictionary, catalogListResponse?.totalCount, catalogStats, pageProps.careerId, pageProps.catalogType]);
};
